import React from 'react';
import { Trade } from '../../services/reportApi';

interface TradesTableProps {
    trades: Trade[];
}

const TradesTable: React.FC<TradesTableProps> = ({ trades }) => {
    const formatCurrency = (value: number) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(value);
    };

    return (
        <section className="section">
            <h2>오늘 거래 ({trades.length}건)</h2>
            {trades.length === 0 ? (
                <div className="empty">거래 내역이 없습니다.</div>
            ) : (
                <div className="trades-table">
                    <table>
                        <thead>
                            <tr>
                                <th>시간</th>
                                <th>구분</th>
                                <th>종목</th>
                                <th>수량</th>
                                <th>가격</th>
                            </tr>
                        </thead>
                        <tbody>
                            {trades.map((trade, index) => (
                                <tr key={index}>
                                    <td>{trade.time}</td>
                                    <td>
                                        <span className={`trade-badge ${trade.side.toLowerCase()}`}>
                                            {trade.side === 'BUY' ? '매수' : '매도'}
                                        </span>
                                    </td>
                                    <td className="symbol">{trade.symbol}</td>
                                    <td>{trade.qty.toFixed(2)}</td>
                                    <td>{formatCurrency(trade.price)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </section>
    );
};

export default TradesTable;
